
            import React, { useEffect, useLayoutEffect, useState } from "react";
import "./index.scss";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";

import ContactService from "../../services/contact.service";
import DataTableDisplay from "../../component/dataTableDisplay";
import { showErrorToaster } from "../../component/toasters/error";
import Loading from "../../component/loading";



const contactService = new ContactService();

function ContactListe() {
  const [contacts, setContact] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth);

  const loadData = async () => {
    setIsLoading(true);

    try {
      const res = await contactService?.getAllContact();
      setContact(res?.data);
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);
  useLayoutEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const columnsContacts = [


    {
      name: "Email",
      selector: (row) => (
        <div className="table-text capitalize">
          {row?.email != null && row?.email}
        </div>
      ),
      sortable: true,
    },
  
   
  ];
  const [hasMore, setHasMore] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  useEffect(() => {
    if (contacts && contacts?.length > 0) {
      setFilteredData(contacts.slice(0, 3));
    }
  }, [contacts]);
  async function fetchMoreData() {
    setTimeout(() => {
      if (filteredData.length >= contacts?.length) {
        setHasMore(false);
        return;
      } else {
        new Promise((resolve) => setTimeout(resolve, 500));

        setFilteredData((prevItems) => {
          // Add real formation data instead of dummy items
          const newItems = contacts.slice(
            prevItems.length,
            prevItems.length + 3
          );
          return [...prevItems, ...newItems];
        });
      }
    }, 500);
  }

  return (
    <section className="usersPage card-globale">
      <div className="container-fluid">
        <div className="row my-0 my-md-5 align-items-center">
          <div className="col-sm text-center text-sm-start">
            <h3 className="title-liste-admin">Contacts liste</h3>
          </div>
        </div>

        {isLoading ? (
          <div className="d-flex my-0 my-md-5  justify-content-center align-items-center"></div>
        ) : (
          <div className="my-5 py-2">
        
              <DataTableDisplay columns={columnsContacts} data={contacts} />
         
    
          </div>
        )}
      </div>
    </section>
  );
}

export default ContactListe;

               
